// deploy/firebase/setup.py 가 Firebase 프로젝트에서 받아 온 웹 앱 설정. 비밀이 아니지만 git 에는 올리지 않는다.
export const firebaseConfig = {
  apiKey: "AIzaSyCSHiDlNkEu1pRZC2sj8-GKgLMOQBUEHoo",
  authDomain: "ai-hunter-9f865.firebaseapp.com",
  projectId: "ai-hunter-9f865",
  storageBucket: "ai-hunter-9f865.firebasestorage.app",
  messagingSenderId: "887785077444",
  appId: "1:887785077444:web:93756531975696dc7e6791",
};
